export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"M16 8c0-2.21-1.79-4-4-4S8 5.79 8 8s1.79 4 4 4 4-1.79 4-4M4 18v2h16v-2c0-2.66-5.33-4-8-4s-8 1.34-8 4\"/>"
};